import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.text.borderLine}`,
          '&.Mui-selected': {
            backgroundColor: theme.palette.background.neutral,
            '&:hover': {
              backgroundColor: 'grey.100',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
        },
        head: {
          color: theme.palette.text.primary,
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
          },
        },
        body: {
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          border: `solid 1px ${theme.palette.text.borderLine}`,
          color: theme.palette.text.primary,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.text.borderLine}`,
          borderTop: 'none',
          borderBottomRightRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,
        },
        toolbar: {
          height: 64,
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        actions: {
          previousButton: {
            bgcolor: 'yellow',
          },
        },
        selectIcon: {
          IconComponent: theme.components?.MuiSvgIcon?.styleOverrides?.root,
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
